// Contracts/ContractTimeline.tsx
import React from 'react';
import { Milestone } from './Contract.interface';
import Timeline from './Timeline';

interface ContractTimelineProps {
  milestones: Milestone[];
}

const ContractTimeline: React.FC<ContractTimelineProps> = ({ milestones }) => {
  return (
    <div className="bg-white shadow rounded-lg p-4">
      <h2 className="text-xl font-bold mb-4">Contract Timeline</h2>
      <Timeline milestones={milestones} />
    </div>
  );
};

export default ContractTimeline;